import { render, staticRenderFns } from "./CouponModal.vue?vue&type=template&id=a1f60e0c&scoped=true"
import script from "./CouponModal.vue?vue&type=script&lang=js"
export * from "./CouponModal.vue?vue&type=script&lang=js"
import style0 from "./CouponModal.vue?vue&type=style&index=0&id=a1f60e0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f60e0c",
  null
  
)

export default component.exports